import { isEmpty } from 'lodash';
import {
  cleanUpColumnOrder,
  ColumnOrder,
} from 'components/organisms/grid-custom-column';
import { FieldFilter } from 'components/organisms/tasks/filters';
import { ApiFilter } from 'utils/simple-search-filter/simple-search-filter';
import { ProjectListViewDefinition } from './types';

export const isValidViewDefinition =
  (defaultColumnOrder: ColumnOrder[]) =>
  (viewDefinition: ProjectListViewDefinition): boolean => {
    return (
      (viewDefinition.filter != null &&
        viewDefinition.filter.criteria.filter(FieldFilter.isValid).length >
          0) ||
      viewDefinition.groupBy !== 'none' ||
      (!isEmpty(viewDefinition.columnOrder) &&
        JSON.stringify(viewDefinition.columnOrder) !==
          JSON.stringify(defaultColumnOrder))
    );
  };

const withKeysForCompare = ({ colId, hide, sort, sortIndex }: ColumnOrder) => ({
  colId,
  hide,
  sort,
  sortIndex,
});

export const viewDefinitionComparator =
  (defaultColumnOrder: ColumnOrder[]) =>
  (
    oldDefinition: ProjectListViewDefinition,
    newDefinition: ProjectListViewDefinition,
  ): boolean => {
    if (oldDefinition.groupBy !== newDefinition.groupBy) {
      return true;
    }
    if (oldDefinition.filter?.type !== newDefinition.filter?.type) {
      return true;
    }

    const oldFilters = (oldDefinition.filter?.criteria ?? []).filter(
      FieldFilter.isValid,
    );
    const newFilters = (newDefinition.filter?.criteria ?? []).filter(
      FieldFilter.isValid,
    );

    if (
      oldFilters.length !== newFilters.length ||
      ApiFilter.toQueryStringFormat(oldFilters) !==
        ApiFilter.toQueryStringFormat(newFilters)
    ) {
      return true;
    }

    const cleanColumns = cleanUpColumnOrder(defaultColumnOrder);
    const oldColumnOrder =
      (isEmpty(oldDefinition.columnOrder)
        ? defaultColumnOrder
        : oldDefinition.columnOrder?.filter(
            (x) => !['projectName', 'plannedDuration_1'].includes(x.colId!),
          ) ?? []) ?? [];
    const newColumOrder =
      (isEmpty(newDefinition.columnOrder)
        ? defaultColumnOrder
        : newDefinition.columnOrder?.filter(
            (x) => !['projectName', 'plannedDuration_1'].includes(x.colId!),
          ) ?? []) ?? [];

    if (
      JSON.stringify(cleanColumns(oldColumnOrder).map(withKeysForCompare)) !==
      JSON.stringify(cleanColumns(newColumOrder).map(withKeysForCompare))
    ) {
      return true;
    }

    return false;
  };
